import { useEffect } from "react";
import { startPlaylistAdvancer } from "./middleware";
import { useAppDispatch, useAppSelector } from '../../store';
import { currentPlaylistSelector } from './selectors';
import { uiActions } from '../ui/slice';

export const usePlaylistAdvancer = () => {
  useEffect(() => startPlaylistAdvancer(), []);
};

export const usePlaylistControls = () => {

  const playlist = useAppSelector(currentPlaylistSelector);
  const resources = useAppSelector(state => state.resources);
  const currentLiveResource = useAppSelector(state => state.ui.currentLiveResource);
  const dispatch = useAppDispatch();

  const currentPlaylistIndex = currentLiveResource?.annotations?.playlistIndex as (number | undefined);

  const go = (index: number) => {
    if (0 <= index && index < playlist.items.length) {
      const targetItem = playlist.items[index];
      const targetResource = targetItem.resource || resources[targetItem.resourceID!];
      dispatch(uiActions.setCurrentLiveResource({
        resource: targetResource,
        annotations: {
          playlistIndex: index
        }
       }));
    }
  };

  return {
    back: () => currentPlaylistIndex !== undefined && go(currentPlaylistIndex - 1),
    forward: () => currentPlaylistIndex !== undefined && go(currentPlaylistIndex + 1),
    go
  };
};
